import {
	NATIVE_AUTH_CODE_PATTERN,
	NATIVE_OAUTH_CALLBACK_PATH,
	NATIVE_OAUTH_CALLBACK_SCHEME,
} from '../../shared/config/native'

type NativeOAuthCallback = { code: string; type: 'success' } | { type: 'error' }

/** Validates an app URL against the exact pending Discogs OAuth request. */
export function parseNativeOAuthCallback(
	value: string,
	expectedState: string,
): NativeOAuthCallback | null {
	let url: URL
	try {
		url = new URL(value)
	} catch {
		return null
	}

	if (
		url.protocol !== `${NATIVE_OAUTH_CALLBACK_SCHEME}:` ||
		url.hostname ||
		url.pathname !== NATIVE_OAUTH_CALLBACK_PATH ||
		url.searchParams.get('state') !== expectedState
	) {
		return null
	}

	const code = url.searchParams.get('code')
	if (code && NATIVE_AUTH_CODE_PATTERN.test(code)) {
		return { code, type: 'success' }
	}

	return url.searchParams.get('error') ? { type: 'error' } : null
}
